import greWordsRaw from '../assets/mock-data/gre-words.json';
import greEssentialVocab from '../assets/mock-data/gre-essential-vocabulary.json';

const nuanceMap = {};
greWordsRaw.forEach((w) => {
  if (w.usage_nuance_fr || w.usage_nuance_en) {
    nuanceMap[w.word.toLowerCase()] = {
      usage_nuance_fr: w.usage_nuance_fr || '',
      usage_nuance_en: w.usage_nuance_en || '',
    };
  }
});

const seen = new Set();
const merged = [];
greEssentialVocab.forEach((w) => {
  const key = w.word.toLowerCase();
  if (seen.has(key)) return;
  seen.add(key);
  const nuance = nuanceMap[key];
  merged.push(nuance ? { ...w, ...nuance } : w);
});
greWordsRaw.forEach((w) => {
  const key = w.word.toLowerCase();
  if (seen.has(key)) return;
  seen.add(key);
  merged.push(w);
});

export const greWordsData = merged;

export const greNuanceMap = nuanceMap;

export default greWordsData;
